
import styled from "styled-components";
import { $red } from "../../assets/colors";

export const RequiredText = styled.span`
  color: ${$red};
`;
